export default __webpack_public_path__ + "static/media/membre_amira.501830fa.JPG";